import { Component, Inject,  OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup,  ValidationErrors, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Cities } from 'app/_models/cities';
import { States } from 'app/_models/states';
import { UserModel, UpdateUserModel } from 'app/_models/user-model';
import { UserStatus } from 'app/_models/user-status';
import { AppRoles } from 'app/_models/roles'
import { Users } from 'app/_models/users';
 
import { AdminService } from 'app/_services/admin.service';
import { StateService } from 'app/_services/state.service';
import { ToastrService } from 'ngx-toastr';
declare const swal: any;

export function customEmailValidator(control: AbstractControl): ValidationErrors | null {
  const email = control.value;
  const emailPattern = /^[a-z0-9._%+-]+@tsiplc\.com$/;

  if (!email) return null;

  if (email.length > 150) {
    return { invalidEmail: 'Email must be 150 characters or fewer.' };
  }

  if (!emailPattern.test(email)) {
    return { invalidEmail: 'Please enter a valid lowercase @tsiplc.com email address.' };
  }

  return null;
}

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.css']
})


export class EditUserComponent implements OnInit {
  editForm: FormGroup;
  @Output() users: UserModel[] = [];
  states: States[];
  state: States;
  cities: Cities[] = [];
  city: Cities;
  editUser: Users;
  roles: AppRoles[] = [];
  userStatus: UserStatus[] = [];
  updateUserModel: UpdateUserModel;
  status: string = '';
  previousRoleId:string = "0";
  currentUser: UserModel;
  isSuperAdmin : boolean = false;

  constructor(
    private readonly router: Router,
    private readonly fb: FormBuilder,
    private readonly stateService: StateService,
    private readonly adminService: AdminService,
    private readonly toastr: ToastrService,
    private readonly dialogRef: MatDialogRef<EditUserComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Users) {
    this.editUser = data;
    this.previousRoleId = data.roleId; 
    this.currentUser = JSON.parse(sessionStorage.getItem('user'));
    let roles = this.currentUser.roles;
    if (roles.length > 0) {
      roles = roles.map(function (x) {
        return x.toUpperCase();
      });
      if (roles.includes("SUPERADMIN")) {
        this.isSuperAdmin = true;
      }
    }
  }

  ngOnInit(): void {
    this.initForm();
    this.getUserStatus();
    this.getStates();
    this.getRoles();
    this.getCitiesByStateId();
  }

  initForm() {
    this.editForm = this.fb.group({
      employeeId: [this.data.employeeId, [Validators.required, Validators.maxLength(20)]],
      firstName: [this.data.firstName, [Validators.required, Validators.maxLength(20)]],
      lastName: [this.data.lastName, [Validators.required, Validators.maxLength(20)]],
      email: [this.data.email, [Validators.required,  customEmailValidator]],
      phoneNumber: [this.data.phoneNumber, [Validators.required, Validators.pattern('[0-9]{10}')]],
      appStatusId: [this.data.appStatusId, [Validators.required]],
      roleId: [this.data.roleId, [Validators.required]],
      stateId: [this.data.stateId, [Validators.required]],
      cityId: [this.data.cityId, [Validators.required]],
    });
  }

  

  onCloseDialog(flag: string): void {
    this.dialogRef.close(flag);
  }

  getStates() {
    this.stateService.getStates().subscribe(states => {
      this.states = states;
      for (let i = 0; i < this.states.length; i++) {
        if (this.states[i].id == this.data.stateId) {
          this.state = this.state[i];
          break;
        }
      }
    });
  }

  getCitiesByStateId() {
    this.stateService.getCityByStateId(this.data.stateId).subscribe(
      response => {
        this.cities = response.cities;
        for (let i = 0; i < response.cities.length; i++) {
          if (this.cities[i].cityId == this.data.cityId) {
            this.cities.push(response.cities[i]);
            break;
          }
        }
      });
  }
  saveUser() {
    if(this.previousRoleId != this.editUser.roleId && !this.isSuperAdmin)
    {
      swal({
        title: "",
        text: "Only Super Admin can update role of a user!",
        type: "error",
        confirmButtonClass: "btn btn-info",
      });
    }
    else{
      swal({
        title: 'Are you sure?',
        text: 'You won\'t be able to revert this!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-danger',
        confirmButtonText: 'YES, Update IT!'
      }).then((result) => {
        if (result === true) {
          this.updateUser()
          this.status = 'Success';
        }
        else {
          this.status = 'Cancelled by User';
          this.toastr.info('result not saved')
        }
      })
    }
  }

  updateUser() {
    this.updateUserModel = {
      userId: this.editUser.id, // Keep this as it's not part of the form
      employeeId: this.editForm.value.employeeId,
      firstName: this.editForm.value.firstName,
      lastName: this.editForm.value.lastName,
      email: this.editForm.value.email,
      phoneNumber: this.editForm.value.phoneNumber,
      appStatusid: this.editForm.value.appStatusId,
      stateId: this.editForm.value.stateId,
      cityId: this.editForm.value.cityId,
      roleId: this.editForm.value.roleId,
      userName: this.editForm.value.email, // Assume username is same as email
    };
    
    this.adminService.updateUser(this.updateUserModel )
    .subscribe(
      data => 
      {   
        if(data.didError) 
        {
          swal({
            title: '',
            text: data.message,
            type: 'error',
            confirmButtonClass: 'btn btn-info'
          });
        } 
        else{
          swal({
            title: '',
            text: data.message,
            type: 'success',
            confirmButtonClass: 'btn btn-info'
          });
        }
        this.dialogRef.close(true);
        this.router.navigateByUrl('user-management');
    },
    (error) => 
    {
      const errorMessage =  error.error?.title ?? error.error ??'Something went wrong. Please contact admin.';
      swal
      ({
        title: '',
        text : errorMessage,
        type: 'error',
        confirmButtonClass: 'btn btn-info'
      });
      this.dialogRef.close(true);
      this.router.navigateByUrl('user-management');
    }
  );
   
  }

  close() {
    this.dialogRef.close(this.status);
  }

  onSelectionchange(e) {
    this.stateService.getCityByStateId(e.value).subscribe(
      state => {
        this.cities = state.cities;
      });
  }

  getUserStatus() {
    this.adminService.getUserStatus().subscribe(result => {
      this.userStatus = result;
    })
  }

  getRoles() {
    this.adminService.getRoles().subscribe(result => {
      this.roles = result.filter((role: AppRoles) => role.roleName !== 'SystemAdmin');
    })
  }


   



}
